import React from 'react';
import { Create, useNotify, useRedirect } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import ConditionDiscountsForm from './ConditionDiscountsForm';

const RESOURCE_NAME = 'resale/conditions';

const ConditionDiscountsCreate = () => {
  const { title } = useTitle('Create Condition Discount Rule');
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Create
      title={title}
      mutationOptions={{
        onSuccess: () => {
          notify('Pricing rule created successfully', { type: 'success' });
          redirect('list', RESOURCE_NAME);
        },
        onError: (error: unknown) => {
          const message = error instanceof Error ? error.message : 'Failed to create pricing rule';
          notify(`Error: ${message}`, { type: 'error' });
        },
      }}
    >
      <ConditionDiscountsForm />
    </Create>
  );
};

export default ConditionDiscountsCreate;
